import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { BarChart } from 'echarts/charts';
import { GridComponent, TooltipComponent, LegendComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';    
import { getColor } from 'helpers/utils';
import PropTypes from 'prop-types'; 
import { Card } from 'react-bootstrap';

echarts.use([BarChart, GridComponent, TooltipComponent, LegendComponent, CanvasRenderer]);

// Préparation des données
const prepareCommissionData = (data) => {
  const groupedByMonthAndYear = {};

  data.forEach(({ checkin, commission }) => {
    const date = checkin?.seconds ? new Date(checkin.toDate()): new Date(); // Utiliser checkin
    const year = date.getFullYear();
    const month = date.getMonth();

    const parsedCommission = parseFloat(commission) || 0;

    if (!groupedByMonthAndYear[year]) {
      groupedByMonthAndYear[year] = Array(12).fill(0);
    }

    groupedByMonthAndYear[year][month] += parsedCommission;
  });

  return groupedByMonthAndYear;
};

const formatDataForChart = (groupedData) => {
    const years = Object.keys(groupedData).sort(); // Trier par année
    const months = [
      'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
      'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre',
    ];
  
    const series = years.map((year) => ({
      name: year,
      type: 'bar',
      // Pas de stack ici pour afficher côte à côte
      data: groupedData[year],
    }));
  
    return { years, months, series };
  };

const getOption = ({ years, months, series }) => ({
  tooltip: {
    trigger: 'axis',
    axisPointer: { type: 'shadow' },
    formatter: (params) => {
      const details = params.map(
        ({ seriesName, data }) =>
          `<br>${seriesName} : ${formatCurrency(data)}`
      );
      return `${params[0].axisValue}${details.join('')}`;
    },
  },
  legend: {
    data: years,
  },
  xAxis: {
    type: 'category',
    data: months,
    axisLabel: { rotate: 45 },
  },
  yAxis: {
    type: 'value',
    name: 'Commissions HT (€)',
    axisLabel: {
        formatter: (value) => {
            if (value === 0) {
              return ''; // Ne pas afficher de label si la valeur est 0
            }
            return formatCurrency(value); // Formater la valeur normalement sinon
          },
      interval: 10, // Afficher un label tous les 5 ticks
    },
    interval: 100000, // Intervalle entre les ticks de l'axe Y
  },
  series, 
  grid: { right: '0', left: '90', bottom: '20%', top: '10%' }
});

const formatCurrency = (value) => {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  }).format(value);
};

const CommissionBarChart = ({ data }) => {
  const groupedData = prepareCommissionData(data); // Utilise checkin
  const chartData = formatDataForChart(groupedData);
  const option = getOption(chartData);

  return (
    // <ReactEChartsCore
    //   echarts={echarts}
    //   option={option}
    //   style={{ height: '400px', minHeight: '300px' }}
    // />
    <Card className="h-100">
          <FalconCardHeader
            title="Commission HT par mois"
            titleTag="h6"
            className="py-2"
            light
            endEl={
              <Flex>
                {/* <Button variant="link" size="sm" as={Link} className="me-2" to="#!">
                  View Details
                </Button>
                <CardDropdown /> */}
              </Flex>
            }
          />
          <Card.Body className="h-100">
            <ReactEChartsCore
              echarts={echarts}
              option={option}
              style={{ height: '100%', minHeight: '17.75rem' }}
            />
          </Card.Body>
        </Card>
  );
};
 export default CommissionBarChart;